import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {withDefaults} from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    maxWidth: { type: Boolean, default: false },
    value: null,
    bgColor: null,
    textColor: null
  },
  setup(__props: any) {

const props = __props as { maxWidth: boolean, value: string, bgColor: string, textColor: string }





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["pl-5 pr-5 pt-2 pb-2 rounded", [__props.bgColor, __props.textColor, {'w-full': __props.maxWidth}]])
  }, _toDisplayString(__props.value), 3))
}
}

})